export const ItemTypes = {
    PLACEABLE_OBJECT: 'placeable-object',
}